import { Get, Put, Delete, HvHostMap } from './helpers';
import { LeaderboardEntry, LeaderboardScoreForProfile, LeaderboardMultiplier } from '@/types/leaderboard.types';
import { IHomepageMainNavItems } from '@/types/homepage.types';

export function SearchLeaderboard(
  eventUUID: string,
  paginationLimit: number,
  paginationOffset: number,
  searchCriteria: string
): Promise<{ results: LeaderboardEntry[]; total: number }> {
  return Get({
    url: `${HvHostMap.eventData}/e3-get-leaderboard/${eventUUID}/${paginationOffset}/${paginationLimit}?${searchCriteria}`,
  });
}

export function GetLeaderboardForUser(
  eventUUID: string,
  paginationLimit: number,
  profileUuid: string
): Promise<{ results: LeaderboardEntry[]; total: number }> {
  return Get({ url: `${HvHostMap.eventData}/e3-get-leaderboard/${eventUUID}/${profileUuid}/${paginationLimit}` });
}

export function UpdateLeaderboardPresets(channel: number, url: string, event_id: number): Promise<string> {
  return Put({ url: `/v3/admin/leaderboard/presets/${channel}`, body: { url, event_id } });
}

export function DeleteLeaderboardPresets(channel: number, event_id: number): Promise<number> {
  return Delete({ url: `/v3/admin/leaderboard/presets/${channel}`, body: { event_id } });
}

export function GetLeaderboardDataForProfile(
  eventUUID: string,
  blProfileUUID: string
): Promise<LeaderboardScoreForProfile[]> {
  return Get({ url: `${HvHostMap.eventData}/e3-get-leaderboard/${eventUUID}/profile/${blProfileUUID}` });
}

export function UpdateActionCustomPoint(
  action: LeaderboardMultiplier,
  channel: number
): Promise<LeaderboardMultiplier> {
  return Put({ url: `/v3/admin/leaderboard/multiplier/${channel}`, body: action });
}

export function LoadActionCustomPoint(channel: number, event_id: number): Promise<LeaderboardMultiplier[]> {
  return Get({ url: `/v3/admin/leaderboard/multipliers/${channel}/${event_id}` });
}

export const AddLeaderboardNavItem = async (eventUuid: string, homepageId: number): Promise<IHomepageMainNavItems> => {
  return Put({ url: `/v3/admin/leaderboard/event/${eventUuid}/homepage/${homepageId}/navitem/create` });
};
